import { StrictMode, type ReactNode } from 'react';
import { Provider } from 'react-redux';
import { makeStore } from './store';

const store = makeStore();

export function Providers({ children }: { children: ReactNode }) {
  return <StrictMode><Provider store={store}>{children}</Provider></StrictMode>;
}
